import React from "react";
// import { useHistory } from "react-router-dom";
import Card from "react-credit-cards";

import {
  formatCreditCardNumber,
  formatCVC,
  formatExpirationDate,
} from "./utils";
import styles from "./styles.css";

import "react-credit-cards/es/styles-compiled.css";

export default class App extends React.Component {
    routeChange=()=> {
        let path = `/`;
        // let history = useHistory();
        this.props.history.push(path);
      }
  render() {
  
    return (
      <div   >
      <h1><br />
        getCredit  <br />
        </h1>
        <div className="App-payment">
           
          <Card
            number="4321********1234"
            name="Johnny John"
            expiry="3099"
            cvc="123"
            focused="number"
           
          />
         
        <h1><br />
    
        User manual<br /></h1>
<h3>
<b>Using getCredit is extremely simple <br /><br />
All that is required is to direct the user to the collection page<br /></b>
In order to build the link correctly it is necessary to prepare two things in advance:<br />
We need to connect to dugoly.com, we need dugoly_uid<br />
Also keep the company logo in easydone's system, we will need logo_id<br />
These two things can be done via the following link:<a href="https://getcredit.link/uploader" > https://getcredit.link/uploader </a><br />
After uploading the logo you will get a link to the logo image, from this link we can get both the dugoly_uid and the logo_id<br />
Example of a link to the logo:<br />
http://www.easydone.online/uploads/-MO0rfu7iS6SO7iFQS2x/ce82985b-09ac-4fcd-a548-1c2410ffeb28.png<br />
<br />
The last parameter is the logo_id (the extension must be included)<br />
And the parameter before it is the dugoly_uid<br />
In this case: <br />
<br />
Your dugoly_uid is :-MO0rfu7iS6SO7iFQS2x<br />
<br />
Your logo_id is :ce82985b-09ac-4fcd-a548-1c2410ffeb28.png<br /><br />
<b>Now we will build the link </b><br />
Explanation of  how to build the link to the collection page:<br />
<br />
In order to direct users to a credit information entry page, you must build the link as follows:<br />
<br />
https://getcredit.link/get-credit-card-details/[dugoly_uid]/[client_id]/[amount]/[business_name]/[logo_id]<br />
<br />
<br />
The business_name is the name of the business as you want it to appear on the collection page<br />
The client_id you enter which code you want, this code means the identification of the customer, so that you can identify who the customer who entered the credit card information<br />
And amount is the transaction amount<br />
In these 3 parameters (business_name, client_id, amount) you can enter any data you want, but do not leave it blank<br />
<br />
<br />
Example of a full link:<br />
https://getcredit.link/get-credit-card-details/-MO0rfu7iS6SO7iFQS2x/client/440$/motto,%20Application%20and%20website%20development/4a0a8bc9-aea3-4e7f-9e40-43bc2831ee98.png<br />
<br />
<b>We're done with what we need to do, now just build a link from your site according to the link we built, and the user will be directed to the collection page<br /><br />
And what happens next?<br /></b>
After the user fills in the details he will be shown a "thank you" message and from here he will be redirected back to your site i.e. to the page from which he came,<br />
To the same URL from which it was redirected for payment, but with the addition of a query parameter ? Received = true<br />
Note: If document.referrer does not work (depending on the reference configuration) it will be returned to the referring page but without the query<br />
The continuation of the service process, you do on your site<br />
<br /><br />

<b>How do you get my customers' credit information?</b><br />
When a customer fills an order for you, his credit information is securely transmitted, and stored in our databases, under your user ID.<br />
And you will receive a notification about the invitation to your email (according to the email stored in the dugoly identification system)<br />
In the message you receive the identification information of the transaction:<br />
The Customer ID<br />
And the transaction identification code (Transaction ID)<br /><br />
You can enter this address:<br />
<a href="https://getcredit.link/details-receiver" >https://getcredit.link/details-receiver</a><br />
You will need to identify yourself in dugoly's identification system (the button is at the top of the page), and enter the customer identification and transaction identification.<br />
After this you will receive the credit details.<br />
Please note, the customer trusts you to carry out the transaction as agreed with him, exactly.<br />
Please make sure of that!<br />
Credit information must also be kept secure<br />
The responsibility is on you!<br />
</h3>
<button className="btn btn-primary btn-block" onClick={()=>{ this.props.history.push('/');}}>back to home</button>

        
         
        </div>
      </div>
    );
  }
}





// WEBPACK FOOTER //
// ./src/User_manual.js